import React, { useEffect, useState } from 'react';
import {
  TUIKit,
  TUIConversationList,
  TUIChat,
  TUIChatHeader,
  TUIMessageList,
  TUIMessageInput,
  TUIProfile,
  TUIConversation,
  TUIManage,
  i18next,
  isPC,
} from '@tencentcloud/chat-uikit-react';
import TencentCloudChat, { ChatSDK, Message } from '@tencentcloud/chat';
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import './style.scss';

import TUIChatEmpty from './TUIChatEmpty';
import { en_US } from '../locales/index';
interface ITasks {
  [key: string]: boolean;
}

interface SocialDemoProps {
  handleTaskList?: (key: string) => void,
  className?: string
  chat?: ChatSDK
}

i18next.addResources(i18next.language, 'translation', en_US);

export default function SocialDemo(props: SocialDemoProps) {
  const { handleTaskList, className } = props;

  const botConversationList = [
    "TUILiveKitDemo001",
    "AK3PWmVXZu3ByVOE",
    "KZJb8oATrgUnETai",
  ];
  const [chat, setChat] = useState<ChatSDK>();
  const [currentLanguage, setCurrentLanguage] = useState<string>("en-US");
  const [currentConversationID, setCurrentConversationID] =
    useState<string>("");

  // TUIMessageInput config
  const TUIMessageInputConfig = {
    className: "sample-h5-input",
    isTransmitter: true,
  };

  useEffect(() => {
    setCurrentLanguage(i18next.language);
    if (props?.chat) {
      const { chat } = props;
      setChat(chat);
    }
  }, [props]);

  const onCurrentConversationID = (conversationID: string) => {
    setCurrentConversationID(conversationID);
  };

  useEffect(() => {
    TUIStore.watch(StoreName.APP, {
      tasks: (tasks: ITasks) => {
        if (tasks.sendMessage) {
          handleTaskList && handleTaskList("send");
        }
        if (tasks.revokeMessage) {
          handleTaskList && handleTaskList("recall");
        }
      },
    });
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: onCurrentConversationID,
    });
    return () => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationID,
      });
    };
  }, [handleTaskList]);

  const handleCreateConversation = async (params: string | any) => {
    // create c2c conversation
    if (typeof params === "string") {
      const { data } = await chat?.getConversationProfile(params);
      handleTaskList && handleTaskList("startChat");
      return data.conversation;
    }

    // create group conversation
    const {
      name,
      type,
      groupID,
      introduction,
      notification,
      avatar,
      maxMemberNum,
      joinOption,
      memberList = [],
      groupCustomField = [],
    } = params;
    const res = await chat?.createGroup({
      name,
      type,
      groupID,
      introduction,
      notification,
      avatar,
      maxMemberNum,
      joinOption,
      memberList,
      groupCustomField,
    });
    const { groupID: createdGroupID } = res.data.group;
    if (type === TencentCloudChat.TYPES.GRP_AVCHATROOM) {
      await chat?.joinGroup({
        groupID: createdGroupID,
        type: TencentCloudChat.TYPES.GRP_AVCHATROOM,
      });
    }
    const { data } = await chat?.getConversationProfile(
      `GROUP${createdGroupID}`
    );
    handleTaskList && handleTaskList("createGroupChat");
    return data.conversation;
  };

  const deleteConversation = async (conversationID: string) => {
    handleTaskList && handleTaskList("deleteChat");
    return chat?.deleteConversation(conversationID);
  };

  const filterConversation = (conversationList: Array<any>) => {
    return conversationList.filter((item) => {
      return (
        item.type !== TencentCloudChat.TYPES.CONV_SYSTEM &&
        !botConversationList.includes(item.conversationID)
      );
    });
  };

  return (
    (isPC && (
      <div className={`${className} sample-chat`}>
        <TUIKit chat={chat} language={currentLanguage}>
          <div className="sample-chat-left-container">
            <TUIProfile className="sample-chat-profile" />
            <TUIConversation
              createConversation={handleCreateConversation}
              deleteConversation={deleteConversation}
            >
              <TUIConversationList filterConversation={filterConversation} />
            </TUIConversation>
          </div>
          <>
            <TUIChat EmptyPlaceholder={<TUIChatEmpty />}>
              <TUIChatHeader />
              <TUIMessageList />
              <TUIMessageInput />
            </TUIChat>
            <TUIManage></TUIManage>
          </>
        </TUIKit>
      </div>
    )) || (
      <div className="sample-chat-h5">
        <TUIKit chat={chat} language={currentLanguage}>
          {!currentConversationID && (
            <div className="sample-chat-h5-container">
              <TUIProfile className="sample-profile" />
              <TUIConversation createConversation={handleCreateConversation}>
                <TUIConversationList filterConversation={filterConversation} />
              </TUIConversation>
            </div>
          )}
          {currentConversationID && (
            <>
              <TUIChat TUIMessageInputConfig={TUIMessageInputConfig}>
                <TUIChatHeader />
                <TUIMessageList />
                <TUIMessageInput />
              </TUIChat>
              <TUIManage></TUIManage>
            </>
          )}
        </TUIKit>
      </div>
    )
  );
}
